/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { IInspectorControlProps } from "./InspectorTypes";
import { InspectPanel, InspectPanelContent } from "../InspectPanel";
import { Inspector } from "../../../inspector";

export interface IInspectSingleNodeProps extends IInspectorControlProps {}

export const InspectSingleNode: React.FC<IInspectSingleNodeProps> = ({ model, path }) => {
	return (
		<InspectPanel>
			<InspectPanelContent>
				<Inspector model={model} />
			</InspectPanelContent>
		</InspectPanel>
	);
};
